import { motion } from 'framer-motion'
import type { SlideProps } from '@/components/SlideWizard'
import elaineImg from '@/assets/elaine-quote.png'
import { useSlideCopy } from '@/lib/i18n'
import { copy } from './Slide4WhyItWorks.copy'

const ease = [0.16, 1, 0.3, 1] as const

export default function Slide4WhyItWorks(_props: SlideProps) {
  const c = useSlideCopy(copy)
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4 mx-auto max-w-5xl">
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2, ease }}
        className="w-full max-w-3xl border-s-4 border-slate-300 ps-6 sm:ps-8 text-start"
      >
        <p className="text-lg sm:text-[1.4rem] text-slate-700 italic leading-relaxed">
          {c.quote}
        </p>
        <div className="mt-5 flex items-center gap-3">
          <img
            src={elaineImg}
            alt={c.imageAlt}
            className="h-10 w-10 rounded-full object-cover shrink-0"
          />
          <p className="text-lg sm:text-xl text-slate-400">
            {c.attribution}
          </p>
        </div>
      </motion.div>
    </div>
  )
}
